import { render, staticRenderFns } from "./Compact.vue?vue&type=template&id=4d4d0d6b&scoped=true"
import script from "./Compact.vue?vue&type=script&lang=js"
export * from "./Compact.vue?vue&type=script&lang=js"
import style0 from "./Compact.vue?vue&type=style&index=0&id=4d4d0d6b&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4d4d0d6b",
  null
  
)

export default component.exports